import React, { useEffect } from 'react';
import OverviewComp from './components/OverviewComp';
import { View } from '../../components/Common/react-native-components';
import { useDispatch } from 'react-redux';
import { clearOnlineReviewData } from './actions/fetchOnlineReviewData';

const OnlineReview = () => {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   return () => dispatch(clearOnlineReviewData());
  // }, []);

  return (
    <View style={{ marginTop: 20 }}>
      <OverviewComp />
    </View>
  );
};
export default OnlineReview;
